import AppProtocol from "@/utils/appProtocol";
import Util from "@/utils/util";
// 导入需要的 Pinia stores
import { useUserStore } from "@/stores/user";
import { useAnalysisStore } from "@/stores/analysis";
import { openProtocol } from "@babybus/lib-protocol";
import type { EnvironmentInitResult } from "@/utils/initMiniProgramEnvironment";
import userBiz from "@/process/userBiz";
import { AnalysisService } from "@/plugins/analysis";

export async function initAppEnvironment(): Promise<EnvironmentInitResult> {
  // 初始化 Pinia stores
  const userStore = useUserStore();
  const analysisStore = useAnalysisStore();

  console.debug("------app环境中------");

  // 尽早解析 src 参数，避免经分事件上报时缺失
  let src1 = Util.getUrlParameterByName("src1", location.search);
  let src2 = Util.getUrlParameterByName("src2", location.search);
  let src3 = Util.getUrlParameterByName("src3", location.search);
  let src4 = Util.getUrlParameterByName("src4", location.search);
  const source: string | null = Util.getUrlParameterByName("source", location.search);
  analysisStore.setSource(source);
  analysisStore.setPlatform(Util.isInApp() ? "App" : Util.isInMiniProgram() ? "小程序" : "其他");
  analysisStore.setSrcParams(src1, src2, src3, src4);
  // 快照首屏完整 query，供页面重载（如支付返回）后还原地址参数
  analysisStore.setEntryQueryString(location.search);

  const headerInfo = await AppProtocol.getHeadInfo();

  userStore.setHeaderInfo(
    Object.assign({}, headerInfo, {
      domain: window.location.host.indexOf("babybus") > -1 ? ".babybus.com" : location.hostname,
    }),
  );

  let isLogin: boolean = await AppProtocol.isLogin();
  let isVip: boolean = await AppProtocol.isVip();
  let baseHeaderInfo = await openProtocol(`babybus://account/getBaseHeadInfo`, {
    headKeys: ["ProductID"],
  });
  let productID: number = baseHeaderInfo?.data?.ProductID || 0;

  // iOS WKWebView 下 JSBridge 在页面加载初期可能未就绪，静默返回 false/0。
  // ProductID 是设备级标识，与登录态无关，正常情况应始终非 0；
  // 若为 0 则说明 JSBridge 未就绪，延迟重试一次。
  if (!productID) {
    // iOS WKWebView 下 JSBridge 就绪时间不稳定，最多重试 3 次，递增延迟
    const retryDelays = [200, 300, 500];
    for (const delay of retryDelays) {
      await new Promise((resolve) => setTimeout(resolve, delay));
      isLogin = await AppProtocol.isLogin();
      isVip = await AppProtocol.isVip();
      baseHeaderInfo = await openProtocol(`babybus://account/getBaseHeadInfo`, {
        headKeys: ["ProductID"],
      });
      productID = baseHeaderInfo?.data?.ProductID || 0;
      if (productID) break;
    }
  }

  userStore.setLoginState(isLogin ? 1 : 0);
  userStore.setVipState(isVip);
  analysisStore.setProductID(productID);

  console.debug("【登录状态】", isLogin);
  console.debug("是否VIP", isVip);

  // 获取用户信息
  if (isLogin) {
    userStore.$state.userInfo = headerInfo?.data || {};
    // 直接调用 store actions
    // userStore.fetchAccountIntegral();
    userStore
      .fetchUserInfo()
      .catch((err) => console.warn(err))
      .finally(() => {
        AnalysisService.setUserInfo(userStore.userInfo);
      });
    // 账号事件数据上报（每天仅一次），透传当前页面全量 query
    userBiz.reportAccountEventData(Util.parseQuery(location.search));
  }

  return {
    env: "app",
    isLogin,
    isVip,
    productID,
  };
}
